import React, { useEffect, useRef, useMemo, useCallback, useState } from 'react'
import { Slider } from 'antd'
import { useSettings } from 'hooks/settings'

const marks = {
  24: {
    style: { fontSize: 24 },
    label: 'Ab',
  },
  30: {
    style: { fontSize: 30 },
    label: 'Ab',
  },
  36: {
    style: { fontSize: 36 },
    label: 'Ab',
  },
  48: {
    style: { fontSize: 48 },
    label: 'Ab',
  },
  60: {
    style: { fontSize: 60 },
    label: 'Ab',
  },
}
export const FontSizer = (props) => {
  const { setFontSize, lyricsText } = useSettings()
  const handleChange = useCallback((value) => {
    setFontSize(value)
  }, [])

  return (
    <Slider
      defaultValue={lyricsText.fontSize}
      marks={marks}
      vertical
      className="font-size"
      min={24}
      max={60}
      onAfterChange={handleChange}
    />
  )
}
